import React from 'react';
import styled, { withTheme } from 'styled-components';
import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import GreetingSectionWithFavs from './GreetingSectionWithFavs';
import GreetingSectionZeroFavs from './GreetingSectionZeroFavs';
import GreetingSectionAnonUser from './GreetingSectionAnonUser';

const GreetingSection = (props) => {
  const {
    globalGreetingSectionConfig,
    locale,
    isUserLoggedIn,
    firstName = '',
    userShopsData = [],
    pageStateModifiers,
    headerSectionData,
    theme,
  } = props;

  const backgroundColor = !isUserLoggedIn()
    ? (headerSectionData && headerSectionData.backgroundColor) || theme.c.bg['feature-1']
    : theme.c.bg.secondary;

  if (!globalGreetingSectionConfig) return (null); // TODO: make component null check

  const hasShopFavs = userShopsData && userShopsData.length > 0;

  const {
    userLoggedInZeroFavouriteShopsLineOne,
    userLoggedInZeroFavouriteShopsLineTwo,
    userLoggedInZeroFavouriteShopsImage,
    userLoggedInZeroFavouriteShopsImageAltText,
    userLoggedInZeroFavouriteShopsCtaText,
    userLoggedInZeroFavouriteShopsCtaUrl,
    userLoggedInZeroFavouriteShopsCtaTagSet,
    userLoggedInWithFavouriteShopsLineOne,
    userLoggedInWithFavouriteShopsLineTwo,
    userLoggedInWithFavouriteShopsCtaText,
    userLoggedInWithFavouriteShopsCtaUrl,
    userLoggedInWithFavouriteShopsCtaTagSet,
  } = globalGreetingSectionConfig;

  const userLoggedInZeroFavouriteComp = (
    <GreetingSectionZeroFavs
      locale={locale}
      userLoggedInZeroFavouriteShopsLineOne={userLoggedInZeroFavouriteShopsLineOne}
      userLoggedInZeroFavouriteShopsLineTwo={userLoggedInZeroFavouriteShopsLineTwo}
      userLoggedInZeroFavouriteShopsImage={userLoggedInZeroFavouriteShopsImage}
      userLoggedInZeroFavouriteShopsImageAltText={userLoggedInZeroFavouriteShopsImageAltText}
      userLoggedInZeroFavouriteShopsCtaText={userLoggedInZeroFavouriteShopsCtaText}
      userLoggedInZeroFavouriteShopsCtaUrl={userLoggedInZeroFavouriteShopsCtaUrl}
      userLoggedInZeroFavouriteShopsCtaTagSet={userLoggedInZeroFavouriteShopsCtaTagSet}
    />
  );

  const userLoggedInWithFavouriteComp = (
    <GreetingSectionWithFavs
      locale={locale}
      userLoggedInWithFavouriteShopsLineOne={userLoggedInWithFavouriteShopsLineOne}
      userLoggedInWithFavouriteShopsLineTwo={userLoggedInWithFavouriteShopsLineTwo}
      userLoggedInWithFavouriteShopsCtaText={userLoggedInWithFavouriteShopsCtaText}
      userLoggedInWithFavouriteShopsCtaUrl={userLoggedInWithFavouriteShopsCtaUrl}
      userLoggedInWithFavouriteShopsCtaTagSet={userLoggedInWithFavouriteShopsCtaTagSet}
      firstName={firstName}
      pageStateModifiers={pageStateModifiers}
      userShopsData={userShopsData}
    />
  );

  const anonUserComp = (
    <GreetingSectionAnonUser
      locale={locale}
      headerSectionData={headerSectionData}
      pageStateModifiers={pageStateModifiers}
    />
  );

  const userLoggedInComp = hasShopFavs
    ? userLoggedInWithFavouriteComp
    : userLoggedInZeroFavouriteComp;

  const renderedComponent = isUserLoggedIn()
    ? userLoggedInComp
    : anonUserComp;

  return (
    <MaxWidthLayout backgroundColor={backgroundColor}>
      {renderedComponent}
    </MaxWidthLayout>
  );
};

export default withTheme(GreetingSection);
